import { CardSvg } from '@/play/cardSvg'

/** Home card art: a dark yard where soft rounded snow sits on a fence, a hut roof and a rock. */
export function SnowCardArt() {
  return (
    <CardSvg bg="#c9d6e2">
      <rect y="150" width="320" height="50" fill="#4f5b3f" />
      {/* snow on the ground: soft rounded drifts */}
      <path d="M0 158 C 30 146, 60 150, 90 156 C 120 162, 150 144, 190 150 C 230 156, 260 146, 320 154 V 200 H 0 Z" fill="#f4f8fc" />
      {/* hut with a rounded cap of snow on the roof */}
      <rect x="40" y="106" width="66" height="46" fill="#a8423a" />
      <path d="M30 108 L 73 74 L 116 108 Z" fill="#4a3a33" />
      <path d="M26 110 C 26 102, 70 66, 73 66 C 76 66, 120 102, 120 110 C 110 114, 36 114, 26 110 Z" fill="#f4f8fc" />
      <rect x="64" y="124" width="16" height="28" fill="#4a3a33" />
      {/* fence: rails with pillowy snow along their tops */}
      {[150, 186, 222, 258, 294].map((x) => <rect key={x} x={x} y="112" width="8" height="42" fill="#7a5236" />)}
      <rect x="146" y="124" width="160" height="6" fill="#7a5236" />
      <rect x="146" y="140" width="160" height="6" fill="#7a5236" />
      <path d="M144 124 C 144 116, 308 116, 308 124 Z" fill="#f4f8fc" />
      <path d="M144 140 C 144 134, 308 134, 308 140 Z" fill="#f4f8fc" />
      {[150, 186, 222, 258, 294].map((x) => <ellipse key={x} cx={x + 4} cy="111" rx="7" ry="4.5" fill="#f4f8fc" />)}
      {[[60, 30], [140, 52], [220, 24], [280, 70], [110, 18], [190, 80]].map(([x, y]) => <circle key={`${x}-${y}`} cx={x} cy={y} r="3" fill="#ffffff" opacity="0.9" />)}
    </CardSvg>
  )
}
